/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'planFilterPipe' })

export class PlanFilterPipe implements PipeTransform {
    transform(items: any[], args: any[]): any {
        if (args.length) {
            const filteredItems = [];
            for (const item of items) {
                if (args.indexOf(item.planCode) > -1) {
                    filteredItems.push(item);
                }
            }
            return filteredItems;
        } else {
            return items;
        }
    }
}

@Pipe({ name: 'regionFilterPipe' })

export class RegionFilterPipe implements PipeTransform {
    transform(items: any[], args: any[]): any {
        if (args.length) {
            const filteredItems = [];
            for (const item of items) {
                if (args.indexOf(item.regionCode) > -1) {
                    filteredItems.push(item);
                }
            }
            return filteredItems;
        } else {
            return items;
        }
    }
}